import React, { useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useHistory } from 'react-router';

import { Button } from '../../components/_shared';
import AccountLayout from '../../components/layout/Account';
import { makeSelectUser } from '../../store/selectors';
import { WarnButton, AdContainer } from './styled';
import { MEMBERSHIP, isEnterprise } from '../../config';
import financialModelsImg from '../../assets/imgs/financial_models_ad.png';
import careerCoachingImg from '../../assets/imgs/career_coaching_ad.png';
import { SurveyResponse } from './SurveyResponse';

const MemberShip = () => {
  const history = useHistory();
  const { name, email, membershipInfo, membership, expireDates, joinedAt } =
    useSelector(makeSelectUser()) || {};

  const handleGotoAccount = () => {
    if (isEnterprise) {
      history.push('/profile');
    } else {
      window.open(
        'https://www.adventuresincre.com/my-account/edit-account/',
        '_blank'
      );
    }
  };
  const handleGotoUpgradeMembership = () => {
    history.push('/logout');
    window.open(
      'https://www.adventuresincre.com/checkout-aero/accelerator-extension/',
      '_self'
    );
  };
  const handleUpgradeAdvanced = () => {
    history.push('/logout');
    window.open(
      'https://www.adventuresincre.com/accelerator/endorsements/',
      '_self'
    );
  };
  const handleCareerAdClick = () => {
    window.open('https://www.adventuresincre.com/career-coaching/', '_blank');
  };
  const handleFinancialAdClick = () => {
    window.open(
      'https://www.adventuresincre.com/financial-models-bundle/',
      '_blank'
    );
  };

  const remainingDays = useMemo(() => {
    if (membershipInfo) {
      if (!membershipInfo.enddate) {
        return 99999;
      }

      const end = moment(new Date(Number(membershipInfo.enddate) * 1000));
      const today = moment().startOf('day');
      return Math.round(moment.duration(end - today).asDays());
    }

    return 0;
  }, [membershipInfo]);

  const expirationDate = useMemo(() => {
    if (isEnterprise) {
      return expireDates && expireDates[0] && expireDates[0].date
        ? moment(new Date(expireDates[0].date)).format('MMMM D, YYYY')
        : 'January 1, 2022';
    } else {
      return (
        (membershipInfo &&
          (Number(membershipInfo.enddate)
            ? moment(Number(membershipInfo.enddate) * 1000).format(
              'MMMM D, YYYY'
            )
            : 'Never')) ||
        'January 1, 2022'
      );
    }
  }, [membershipInfo, expireDates]);

  return (
    <AccountLayout>
      {remainingDays <= 90 && !isEnterprise && (
        <WarnButton
          isAlert={remainingDays < 0}
          onClick={handleGotoUpgradeMembership}
        >
          {remainingDays <= 0 ? (
            <>
              Your account has expired.&nbsp;<b>Click here</b>&nbsp;to extend
              your membership now.
            </>
          ) : (
            <>
              {remainingDays}Your Accelerator Membership expires on{' '}
              {(membershipInfo &&
                (Number(membershipInfo.enddate)
                  ? moment(Number(membershipInfo.enddate) * 1000).format(
                    'MMMM D, YYYY'
                  )
                  : 'Never')) ||
                'January 1, 2022'}
              . &nbsp;
              <b>Click here</b>&nbsp;to extend your membership for 6 more
              months.
            </>
          )}
        </WarnButton>
      )}
      <div className="text-lg font-semibold text-black tracking-widest sm:text-xl sm:ml-4">
        Membership details
      </div>
      <div className="p-4 mt-3">
        <div className="flex items-center mb-2">
          <div className="text-lg font-bold text-black sm:text-regular mr-3">
            {name}
          </div>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path
                d="M12.5837 1.0875C12.2473 0.743175 11.8454 0.469576 11.4017 0.282779C10.958 0.0959817 10.4814 -0.000244141 9.99997 -0.000244141C9.51855 -0.000244141 9.04198 0.0959817 8.59828 0.282779C8.15458 0.469576 7.75268 0.743175 7.41622 1.0875L6.63872 1.885L5.52622 1.87125C5.04466 1.86555 4.56682 1.9562 4.1208 2.13786C3.67478 2.31952 3.26958 2.58853 2.92904 2.92907C2.5885 3.26961 2.31949 3.67481 2.13783 4.12083C1.95617 4.56685 1.86552 5.04469 1.87122 5.52625L1.88372 6.63875L1.08872 7.41625C0.744396 7.75271 0.470796 8.1546 0.283999 8.59831C0.0972024 9.04201 0.000976563 9.51858 0.000976562 10C0.000976563 10.4814 0.0972024 10.958 0.283999 11.4017C0.470796 11.8454 0.744396 12.2473 1.08872 12.5838L1.88497 13.3612L1.87122 14.4738C1.86552 14.9553 1.95617 15.4332 2.13783 15.8792C2.31949 16.3252 2.5885 16.7304 2.92904 17.0709C3.26958 17.4115 3.67478 17.6805 4.1208 17.8621C4.56682 18.0438 5.04466 18.1345 5.52622 18.1287L6.63872 18.1163L7.41622 18.9112C7.75268 19.2556 8.15458 19.5292 8.59828 19.716C9.04198 19.9028 9.51855 19.999 9.99997 19.999C10.4814 19.999 10.958 19.9028 11.4017 19.716C11.8454 19.5292 12.2473 19.2556 12.5837 18.9112L13.3612 18.115L14.4737 18.1287C14.9553 18.1345 15.4331 18.0438 15.8791 17.8621C16.3252 17.6805 16.7304 17.4115 17.0709 17.0709C17.4114 16.7304 17.6804 16.3252 17.8621 15.8792C18.0438 15.4332 18.1344 14.9553 18.1287 14.4738L18.1162 13.3612L18.9112 12.5838C19.2555 12.2473 19.5291 11.8454 19.7159 11.4017C19.9027 10.958 19.999 10.4814 19.999 10C19.999 9.51858 19.9027 9.04201 19.7159 8.59831C19.5291 8.1546 19.2555 7.75271 18.9112 7.41625L18.115 6.63875L18.1287 5.52625C18.1344 5.04469 18.0438 4.56685 17.8621 4.12083C17.6804 3.67481 17.4114 3.26961 17.0709 2.92907C16.7304 2.58853 16.3252 2.31952 15.8791 2.13786C15.4331 1.9562 14.9553 1.86555 14.4737 1.87125L13.3612 1.88375L12.5837 1.08875V1.0875ZM12.9425 8.5675L9.19247 12.3175C9.13441 12.3757 9.06544 12.4219 8.98951 12.4534C8.91358 12.4849 8.83218 12.5011 8.74997 12.5011C8.66776 12.5011 8.58636 12.4849 8.51043 12.4534C8.4345 12.4219 8.36553 12.3757 8.30747 12.3175L6.43247 10.4425C6.37436 10.3844 6.32827 10.3154 6.29682 10.2395C6.26537 10.1636 6.24918 10.0822 6.24918 10C6.24918 9.91782 6.26537 9.83644 6.29682 9.76052C6.32827 9.6846 6.37436 9.61561 6.43247 9.5575C6.49058 9.49939 6.55957 9.45329 6.63549 9.42185C6.71142 9.3904 6.79279 9.37421 6.87497 9.37421C6.95715 9.37421 7.03853 9.3904 7.11445 9.42185C7.19037 9.45329 7.25936 9.49939 7.31747 9.5575L8.74997 10.9913L12.0575 7.6825C12.1748 7.56514 12.334 7.49921 12.5 7.49921C12.6659 7.49921 12.8251 7.56514 12.9425 7.6825C13.0598 7.79986 13.1258 7.95903 13.1258 8.125C13.1258 8.29097 13.0598 8.45014 12.9425 8.5675Z"
                fill="#E8B12C"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>

        <div className="text-base text-gray-200">{email}</div>
        <div className="py-4 my-4">
          <div className="text-regular text-gray-200 mb-2">
            <span className="font-bold text-black">Membership Level: </span>
            {isEnterprise ? 'Enterprise' : membership === MEMBERSHIP.ACCELERATOR_CORE ? 'Core' : 'Advanced'}
          </div>
          <div className="text-regular text-gray-200 mb-2">
            <span className="font-bold text-black">Enrollment date: </span>
            {moment(
              joinedAt ||
              Number(membershipInfo && membershipInfo.startdate) * 1000
            ).format('MMMM D, YYYY') || 'January 1, 2021'}
          </div>
          <div className="text-regular text-gray-200">
            <span className="font-bold text-black">Expiration date: </span>
            {expirationDate}
          </div>
        </div>
        <div className="flex items-center sm:flex-col sm:px-10">
          {!isEnterprise && membership === MEMBERSHIP.ACCELERATOR_CORE && (
            <Button
              className={`font-semibold mr-4 py-2 px-4 border border-solid rounded-lg text-white bg-primary sm:w-full sm:mb-2 sm:mr-0`}
              type="misc"
              caption="Upgrade to Advanced"
              onClick={handleUpgradeAdvanced}
            />
          )}
          {!isEnterprise && (
            <Button
              className={`font-semibold mr-4 py-2 px-4 border border-solid rounded-lg text-white bg-primary sm:w-full sm:mb-2 sm:mr-0`}
              type="misc"
              caption="Extend Membership"
              onClick={handleGotoUpgradeMembership}
            />
          )}
          <Button
            className={`font-semibold py-2 px-4 border border-solid rounded-lg text-white bg-primary sm:w-full`}
            type="misc"
            caption="Edit Account Details"
            onClick={handleGotoAccount}
          />
        </div>

        {false && (
          <>
            <div className="text-2xl font-semibold my-3">Survey Response</div>
            <div
              className="bg-white rounded-lg mt-2 p-4 max-h-96 overflow-auto"
              style={{ maxHeight: 500 }}
            >
              <SurveyResponse email={email} />
            </div>
          </>
        )}
      </div>
      {!isEnterprise && (
        <>
          <AdContainer onClick={handleFinancialAdClick}>
            <img src={financialModelsImg} alt="financial_models_ad_img" />
          </AdContainer>
          <AdContainer onClick={handleCareerAdClick}>
            <img src={careerCoachingImg} alt="career_coaching_ad_img" />
          </AdContainer>
        </>
      )}
    </AccountLayout>
  );
};

export default MemberShip;
